import React from "react";
import Routes from "./Routes";

function App() {
  return (
    <div className="min-h-screen bg-gradient-dark dark-theme">
      <Routes />
    </div>
  );
}

export default App;